module.exports = __webpack_public_path__ + "img/icon4.258fa3b5.png";